import React, { Component } from 'react';
import Pagination from '../../Pagination';
import Select from '../../Select';
import FormControl from '../../-FormControl';

class ReferPagination extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageSizeValue: props.defaultPageSize,
            pageIndexValue: '1',
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.activePage !== prevProps.activePage) {
            this.setState({ pageIndexValue: String(this.props.activePage) });
        }
    }

    render() {
        let { pageSizeValue, pageIndexValue, searchValue } = this.state,
            { pageSizeOptions, local, onPageSizeChange, onPageIndexChange, items, activePage, total = 0 } = this.props;
        // total = total > 0 ? total : (pageSizeValue * items);
        return <>
            <div className="refer-pagesize-selector">
                {/* <Select
                    value={pageSizeValue + `${local["containers-refer-0056"]}/${local["containers-refer-0057"]}`}
                    showSearch 
                    supportWrite  
                    supportSearch
                    showClear={false}
                    onChange={pageSize => {
                        pageSize = Number(pageSize);
                        if (!isNaN(pageSize)) {
                            let formattedValue = Math.max(1, Math.min(pageSize, 5000));
                            this.setState({ pageSizeValue: formattedValue });
							onPageSizeChange?.(formattedValue);
                        }
	                        
                    }}
                    onKeyDown={event => {
                        if (event.which === 13) {
                            event.stopPropagation();
                            let pageSize = Number(event.target.value);
                            if (!isNaN(pageSize)) {
                                let formattedValue = Math.max(1, Math.min(pageSize, 5000));
                                this.setState({ pageSizeValue: formattedValue });
									onPageSizeChange?.(formattedValue);
                            }
                        }
                    }}
                    onFocus={() => {
                        this.setState({ searchValue: '' });
                    }}
                    onSearch={value => {
                        this.setState({ searchValue: value });
                    }}
                    dropdownClassName={searchValue && !pageSizeOptions.find(e => String(e).includes(searchValue)) ? 'refer-select-hidden' : ''}
                >
                    {pageSizeOptions.map(pageSize => 
                    // 条/页
                        <Select.Option key={pageSize} value={pageSize}>{pageSize}{local["containers-refer-0056"]}/{local["containers-refer-0057"]}</Select.Option>,
                    )}
                </Select> */}
            </div>
            <div className="refer-totalpage">
                {/* 共99条 */}
            </div>
            <div className="refer-page-extend" />
            <div className="refer-pagination">
                <Pagination
                    ncHotKeyboard={false}
                    // prev
                    // next
                    // boundaryLinks
                    total={total}
                    showJump={false}
                    maxButtons={5}
                    // gap={true}
                    showSizeChanger={true}
                    pageSizeOptions={pageSizeOptions}
                    pageSize={pageSizeValue}
                    current={activePage}
                    onChange={pageIndex => {
                        let formattedValue = Math.max(1, Math.min(Number(pageIndex), items));
                        this.setState({ pageIndexValue: String(formattedValue), activePage: formattedValue });
                        onPageIndexChange?.(formattedValue);
                    }}
                    onPageSizeChange={(index, pageSize) => {
                        let formattedValue = Math.max(1, Math.min(pageSize, 5000));
                        this.setState({ pageSizeValue: formattedValue });
                        onPageSizeChange?.(formattedValue);
                    }}
                // showJump
                />
            </div>
            <div className="refer-pagination-jump">
                {/* 跳至第 */}
                {/* <span>
                    {local['containers-refer-0058']?.split('{0}')[0]}
                </span>
                <FormControl
                    value={pageIndexValue}
                    onChange={value => {
                        value = Number(value);
                        if (!isNaN(value)) {
                            this.setState({ pageIndexValue: value });
                        }
                    }}
                    onBlur={() => {
                        let formattedValue = Math.max(1, Math.min(Number(pageIndexValue), items));
                        this.setState({ pageIndexValue: String(formattedValue), activePage: formattedValue });
                        onPageIndexChange?.(formattedValue);
                    }}
                    onKeyDown={event => {
                        if (event.which === 13) {
                            event.stopPropagation();
                            let formattedValue = Math.max(1, Math.min(Number(pageIndexValue), items));
                            this.setState({ pageIndexValue: String(formattedValue), activePage: formattedValue });
                            onPageIndexChange?.(formattedValue);
                        }
                    }}
                /> */}
                {/* 页 */}
                {/* <span>
                    {local['containers-refer-0058']?.split('{0}')[1]}
                </span> */}
            </div>
        </>;
    }
}

export default ReferPagination;